import { actions } from 'data'
import { put } from 'redux-saga/effects'

export default function* finalStep() {
  yield put(actions.app.hideModal('TIER_TWO'))
  yield put(actions.auth.pollUser())
}
